<template>
    <div>
        <c-inspection-data
            :has-data    = "!!data"
            :show-header = "false"
            :height      = "height"
            :title       = "$t('disposition.unit.menu')"
        >
            <template v-slot:body>
                <!--
                    escalator data captured in the SmartLift app (HCIT-934), shown for escalators and moving walks (HCIT-937);
                    the device type reported by the app decides, else the data (HCIT-1190)
                -->
                <div v-if="!!data && isEscalator" class="pr-1 pl-3 pt-1">
                    <div class="v-flex w-100">
                        <div class="w-50 pr-2">
                            <c-name-value-header :title="$t('unit.escalator.general')" />
                            <c-name-value-row :label="$t('unit.escalator.kind')"               property="kind"               type="siteEscalatorKind"      :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.manufacturer')"       property="manufacturer"       type="manufacturer"           :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.yearOfConstruction')" property="yearOfConstruction"                               :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.rebuilder')"          property="rebuilder"          type="manufacturer"           :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.yearOfRebuild')"      property="yearOfRebuild"                                    :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.model')"              property="model"                                            :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.auditBook')"          property="auditBookLocation"  type="siteEscalatorAuditBook" :data="escalator" />

                            <c-name-value-header :title="$t('unit.escalator.mounting')" class="mt-6" />
                            <c-name-value-row :label="$t('unit.escalator.floorRange')"         property="floorRange"                                       :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.drivingDirection')"   property="direction"                                        :data="escalatorView" />
                            <c-name-value-row :label="$t('unit.escalator.mountingPosition')"   property="mountingPosition"   type="siteEscalatorMountingPosition" :data="escalator" />
                        </div>
                        <div class="w-50 pl-2">
                            <c-name-value-header :title="$t('unit.escalator.technical')" />
                            <c-name-value-row :label="$t('unit.escalator.liftingHeight')"         property="liftingHeight"         :data="escalatorView" />
                            <c-name-value-row :label="$t('unit.escalator.gradient')"              property="gradient"              :data="escalatorView" />
                            <c-name-value-row :label="$t('unit.escalator.stepWidthMm')"           property="stepWidthMm"           :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.horizontalStepsTop')"    property="horizontalStepsTop"    :data="escalator" />
                            <c-name-value-row :label="$t('unit.escalator.horizontalStepsBottom')" property="horizontalStepsBottom" :data="escalator" />

                            <c-name-value-header :title="$t('unit.escalator.features')" class="mt-6" />
                            <c-name-value-row :label="$t('unit.escalator.lighting.title')" property="lighting"  :data="escalatorView" />
                            <c-name-value-row :label="$t('unit.escalator.sprinkler')"       property="sprinkler" :data="escalatorView" />
                            <c-name-value-row :label="$t('unit.escalator.otherFeatures')"   property="features"  :data="escalator" />

                            <c-name-value-header title = "ZÜS Prüfung" class="mt-6" />
                            <c-name-value-row label="Nächste Prüfung - Monat" property="nextMonth" :data="data"  />
                            <c-name-value-row label="Nächste Prüfung - Jahr"  property="nextYear"  :data="data"  />
                            <c-name-value-row label="ZÜS" property="zus" type="zus" :data="data"  />
                        </div>
                    </div>
                </div>
                <div v-else-if="!!data" class="pr-1 pl-3 pt-1">
                    <div class="">
                        <div class="v-flex w-100">
                            <div class="w-50 pr-2">
                                <c-name-value-header title = "Allgemeine Daten" />
                                <c-name-value-row label="Hersteller"      property="manufacturer"           type="manufacturer"               :data="data"  />
                                <c-name-value-row label="Baujahr"         property="yearOfConstruction"                                       :data="data"  />
                                <c-name-value-row label="Umbaufirma"      property="rebuilder"              type="manufacturer"               :data="data"  />
                                <c-name-value-row label="Umbaujahr"       property="yearOfRebuild"                                            :data="data"  />
                                <c-name-value-row label="ggf. Typ"        property="additionalType"                                           :data="data"  />
                                <c-name-value-row label="Anlagenart"      property="type"                   type="siteType"                   :data="data"  />
                                <c-name-value-row label="Errichtungsnorm" property="installationRegulation" type="siteInstallationRegulation" :data="data"  />
                                <c-name-value-row label="Antriebsart"     property="typeOfDrive"            type="siteTypeOfDrive"            :data="data"  />
                                <c-name-value-row label="Aufhängung"      property="typeOfSuspension"       type="siteTypeOfSuspension"       :data="data"  />
                                <c-name-value-row label="Prüfbuch"        property="locationElevatorBook"   type="siteLocationElevatorBook"   :data="data"  />
                                <c-name-value-row label="Schachtwände"    property="shaftWall"              type="siteShaftWallType"          :data="data"  />
                            </div>
                            <div class="w-50 pl-2">
                                <c-name-value-header title = "Gruppe / Triebwerksraum" />

                                <p-elevator-group-position
                                    v-if="data.posInGroup"
                                    v-model            = "data.posInGroup"
                                    :type-of-group     = "data.typeOfGroup ? data.typeOfGroup.id : null"
                                    :readonly          = "true"
                                />
                            </div>
                        </div>

                        <div class="v-flex w-100 pb-2">
                            <div class="w-50 pr-2">
                                <c-name-value-header title = "Technische Daten" class="mt-6" />
                                <c-name-value-row label="Tragfähigkeit in kg"       property="loadCapacityKg"                               :data="data"  />
                                <c-name-value-row label="Tragfähigkeit in Personen" property="loadCapacityPeople"                           :data="data"  />
                                <c-name-value-row label="Haltestellen"              property="stops"                                        :data="data"  />
                                <c-name-value-row label="Zugangsstellen"            property="entrypoints"                                  :data="data" />
                                <c-name-value-row label="Türbreite in m"            property="doorWidth"                                    :data="data" />
                                <c-name-value-row label="Türhöhe in m"              property="doorHeight"                                   :data="data" />
                                <c-name-value-row label="Anzahl Tragmittel"         property="carrierMediumCount"                           :data="data" />
                                <c-name-value-row label="Art der Tragmittel"        property="carrierMedium"         type="siteCarrierType" :data="data"  />
                                <c-name-value-row label="Ø der Tragmittel in mm"    property="carrierMediumDiameter"                        :data="data" />
                            </div>
                            <div class="w-50 pl-2">
                                <c-name-value-header title = "ZÜS Prüfung" class="mt-6" />
                                <c-name-value-row label="Frist für widerkehrende Prüfung" property="deadline"  :data="data"  />
                                <c-name-value-row label="Nächste Prüfung - Monat"         property="nextMonth" :data="data"  />
                                <c-name-value-row label="Nächste Prüfung - Jahr"          property="nextYear"  :data="data"  />
                                <c-name-value-row label="ZÜS" property="zus" type="zus" :data="data"  />

                                <c-name-value-header title = "Nutzung / Gebäude" class="mt-8" />
                                <c-name-value-row label="Gebäudeart"         property="buildingType"   type="siteBuildingType"   :data="data"  />
                                <c-name-value-row label="Nutzungsart"        property="typeOfUse"      type="siteTypeOfUse"      :data="data"  />
                                <c-name-value-row label="Nutzungshäufigkeit" property="frequenceOfUse" type="siteFrequenceOfUse" :data="data"  />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </c-inspection-data>
    </div>
</template>

<script>

import PAreaMixin             from "@/modules/dis/components/inspection/common/mixins/PAreaMixin";
import CInspectionData        from "@/modules/dis/components/inspection/common/components/CInspectionData.vue";
import CNameValueRow          from "@/modules/dis/components/inspection/common/components/CNameValueRow.vue";
import CNameValueHeader       from "@/modules/dis/components/inspection/common/components/CNameValueHeader.vue";
import PElevatorGroupPosition from "@/modules/dis/components/inspection/elevator/components/private/PElevatorGroupPosition.vue";
import Escalator              from "@/modules/msd/unit/service/Escalator";
import UnitDataLayout         from "@/modules/dis/service/inspection/UnitDataLayout";

export default {
    name: "PDispositionElevatorData",

    components: {
        PElevatorGroupPosition,
        CNameValueHeader,
        CNameValueRow,
        CInspectionData,
    },

    mixins: [
        PAreaMixin
    ],

    computed: {
        /**
         * Whether the escalator view is shown: the device type reported by the app, else the escalator data (HCIT-1190).
         * After a change from escalator to elevator in the app the escalator specification stays in the backend.
         */
        isEscalator () {
            return UnitDataLayout.isEscalator(this.inspection);
        },

        /** Escalator specification of the inspection (`elevator.escalator`, HCIT-934); empty if none was captured. */
        escalator () {
            return this.data && this.data.escalator ? this.data.escalator : {};
        },

        /** Values of the escalator specification that are shown as text. */
        escalatorView () {
            const lighting = Escalator.lightingText(this.escalator.lighting, key => this.$t("unit.escalator.lighting." + key));
            return {
                direction    : Escalator.directionText(this.escalator.drivingDirection),
                liftingHeight: Escalator.numberText(this.escalator.liftingHeight),
                gradient     : Escalator.numberText(this.escalator.gradient),
                lighting     : lighting.length > 0 ? lighting.join(", ") : null,
                sprinkler    : this.escalator.sprinkler === true ? "ja" : (this.escalator.sprinkler === false ? "nein" : null),
            };
        },
    },

    mounted () {
        this.initialize();
    },

    watch: {
        inspection () {
            this.initialize();
        },
    },

    methods: {
        initialize () {
            if (!this.inspection) {
                return;
            }

            this.data = this.inspection.elevator;
        },

        name (id, type) {
            const list = this.$store.getters.msd[type];
            if (list) {
                const item = list.find (i => i.id === id);
                if (item) {
                    return item.name;
                }
            }

            return "---";
        },
    }
}
</script>

<style scoped>

</style>